import { jsx as _jsx } from "react/jsx-runtime";
import styles from './ChartDot.module.css';
const ChartDot = ({ cx, cy, payload, color = 'currentColor' }) => {
    if (!payload || !cy || !cx) {
        return null;
    }
    return (_jsx("circle", { r: "4", fill: color, cx: cx, cy: cy, className: styles[((payload === null || payload === void 0 ? void 0 : payload.priorityLevel) || 'regular').toLowerCase()] }, void 0));
};
export default ChartDot;
